<template>
    <div class="modal fade" id="tasksFeedbackModal" tabindex="-1" role="dialog" data-backdrop="static">
        <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">{{ $lang('Ocena obsługi zgłoszeń') }}</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <p>{{$lang('Prosimy o ocenę obsługi poniższych zgłoszeń:')}}</p>
                    <table class="table simple-table table-striped table-sm">
                        <thead class="thead-dark">
                        <tr>
                            <th scope="col">{{ $lang('ID') }}</th>
                            <th scope="col">{{ $lang('Temat') }}</th>
                            <th scope="col" class="text-md-center">{{ $lang('Status') }}</th>
                            <th scope="col" class="text-md-center">{{ $lang('Szczegóły') }}</th>

                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="task in tasks">
                            <td :data-title="$lang('ID')" class="col-md-1">{{ task.id }}</td>
                            <td :data-title="$lang('Temat')" class="col-md-7">{{ task.subject }}</td>
                            <td :data-title="$lang('Status')" class="col-md-2 text-md-center">
                                <span :class="['badge', 'badge-' + status_badge_prefix + task.status]">{{task.get_status.name}}</span>
                            </td>
                            <td :data-title="$lang('Szczególy')" class="col-md-2 text-md-center">
                                <a :href="task.url" target="_blank">{{$lang('Przejdź')}}</a>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>
                <div class="modal-footer">
                    <button class="btn btn-default" data-dismiss="modal">{{ $lang('Ocenię później') }}</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: ['url', 'status_badge_prefix'],
    data() {
        return {
            tasks: []
        }
    },
    mounted() {
        $('#tasksFeedbackModal').on('show.bs.modal', this.getTasksToFeedback);
    },
    methods: {
        getTasksToFeedback() {
            let self = this;
            axios.get(this.url)
                 .then(function (response) {
                     self.tasks = response.data.tasks;
                 })
                 .catch((error) => {
                     console.log(error);
                 })
                 .finally(() => {
                     $('#tasksFeedbackModal').modal('show');
                 });
        }
    }
}
</script>

